import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import makePendingActions from '../../models/pending/actions';
import TextInput from '../TextInput';
var pendingActions = makePendingActions({});

var isNumberInput = function isNumberInput(t) {
  return Boolean(t) && t === "number";
};
/**
 * Wraps a TextInput and connects it to the pending data model. Automatically
 * sets the initial data for the input and updates the pending data whenever
 * a change event is fired.
 *
 * @public
 * @author Connor Taylor
 */


export var PendingInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(PendingInput, _Component);

  function PendingInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (e) {
      var _changes;

      var _this$props = _this.props,
          updatePendingData = _this$props.updatePendingData,
          pendingKey = _this$props.pendingKey,
          valueKey = _this$props.valueKey,
          onChange = _this$props.onChange;
      var value = e.target ? e.target.value : e;
      updatePendingData({
        changes: (_changes = {}, _changes[valueKey] = value, _changes),
        id: pendingKey
      });

      if (onChange) {
        onChange(e);
      }
    });

    return _this;
  }

  var _proto = PendingInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _changes2;

    var _this$props2 = this.props,
        updatePendingData = _this$props2.updatePendingData,
        pendingKey = _this$props2.pendingKey,
        valueKey = _this$props2.valueKey,
        initialData = _this$props2.initialData,
        type = _this$props2.type,
        value = _this$props2.value;

    if (value) {
      return;
    }

    var initialValue = isNumberInput(type) && !initialData ? 0 : initialData;
    updatePendingData({
      changes: (_changes2 = {}, _changes2[valueKey] = initialValue, _changes2),
      id: pendingKey
    });
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        updatePendingData = _this$props3.updatePendingData,
        pendingKey = _this$props3.pendingKey,
        valueKey = _this$props3.valueKey,
        initialData = _this$props3.initialData,
        rest = _objectWithoutPropertiesLoose(_this$props3, ["updatePendingData", "pendingKey", "valueKey", "initialData"]);

    return React.createElement(TextInput, _extends({}, rest, {
      onChange: this.onChange
    }));
  };

  return PendingInput;
}(Component);
PendingInput.defaultProps = {
  initialData: ""
};
export default connect(function (state, props) {
  var pendingKey = props.pendingKey,
      valueKey = props.valueKey,
      type = props.type;
  var value = state.pending && state.pending.data && state.pending.data[pendingKey] && state.pending.data[pendingKey][valueKey]; // Default value is 0 for numbers

  var defaultValue = type && type === "number" ? 0 : ""; // Make value the empty string by default to prevent any uncontrolled
  // component warnings from popping up

  return {
    value: value || defaultValue
  };
}, {
  updatePendingData: pendingActions.updatePendingData
})(PendingInput);